import React from "react";


const PolicyPage = () => {


  return (
   <>
   <h1>Congrat's you got a website that got no privacy policies.</h1>
   </>
  );
};

export default PolicyPage;
